import Vue from 'vue'

import { library } from '@fortawesome/fontawesome-svg-core'

// import {

// } from '@fortawesome/pro-regular-svg-icons'

import {
  faBars,
  faSearch,
  faStar,
  faSquare,
  faCheckSquare,
  faSortUp,
  faSortDown,
  faGripHorizontal,
  faGripVertical,
  faGripLines,
  faQuestionCircle,
  faChevronLeft,
  faChevronRight,
  faArrowsAltV,
  faArrowsAltH,
  faSortAmountDownAlt as faSortAmountDownAltSolid,
  faTimes,
  faGlobe,
} from '@fortawesome/pro-solid-svg-icons'

import {
  faCalendar,
  faUsers,
  faDownload,
  faSignInAlt,
  faFilePdf,
  faSignOutAlt,
  faSortAmountDownAlt as faSortAmountDownAltDuotone,
  faClock,
  faCalendarPlus,
} from '@fortawesome/pro-duotone-svg-icons'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(
  faBars,
  faSearch,
  faCalendar,
  faUsers,
  faStar,
  faDownload,
  faSquare,
  faCheckSquare,
  faSortUp,
  faSortDown,
  faGripHorizontal,
  faGripVertical,
  faGripLines,
  faQuestionCircle,
  faSignInAlt,
  faChevronLeft,
  faChevronRight,
  faSignOutAlt,
  faFilePdf,
  faArrowsAltV,
  faArrowsAltH,
  faSortAmountDownAltSolid,
  faSortAmountDownAltDuotone,
  faTimes,
  faClock,
  faCalendarPlus,
  faGlobe,
)

Vue.component('font-awesome-icon', FontAwesomeIcon)
